import React from "react";
import Form from "./Form";

function Part(props) {
  const actionState = props?.location.state;
  const type = window.location.href.includes("update-") ? "Update" : "Add";
  return (
    <div>
      <Form
        pageName={`${type === "Update" ? "Update" : "New"} Part`}
        assetType="Part"
        state={actionState?.action}
        type={type}
      />
    </div>
  );
}

export default Part;
